/**
 * @returns true if price is 0.
 */
export const isFreePlan = plan => {
  var _plan$pricing, _plan$pricing$price;
  return ((_plan$pricing = plan.pricing) == null ? void 0 : (_plan$pricing$price = _plan$pricing.price) == null ? void 0 : _plan$pricing$price.value) === '0';
};
//# sourceMappingURL=is-free-plan.js.map